import { Component, ViewChild } from '@angular/core';
import { TransferHttpService } from '../../services/transfer-http/transfer-http.service';
import { ActivatedRoute } from '@angular/router';
import { PermissionsService } from '../../services/permissions/permissions.service';
import { EngCadDrawings } from '../../../models';
import { NgForm } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { AimsCommonConfirmDialogComponent, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions } from '@aims/common-components';
import { MessageService } from 'src/app/services/message/message.service';
import { DialogComponent } from 'src/app/services/message/message.enum';
import { MatDialog } from '@angular/material/dialog';
import { AIMS_NUMERIC_TYPES } from 'src/app/components/aims-numeric/aims-numeric.component';

@Component({
  selector: 'drawing',
  templateUrl: './drawing.component.html'
})

export class DrawingComponent {

  constructor(public transferHttp: TransferHttpService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private dialog: MatDialog,
    public permissions: PermissionsService) {
  }

  AIMS_NUMERIC_TYPES = AIMS_NUMERIC_TYPES;

  // AimsCommonTable setup
  tableHeader: AimsCommonTableHeader[] = [
    { key: 'action', label: 'Action', type: AimsCommonTableHeaderType.STRING, filter: false },
    { key: 'changedBy', label: "Changed By", type: AimsCommonTableHeaderType.DYNAMIC, },
    { key: 'changeDateTime', label: "Changed On", type: AimsCommonTableHeaderType.DATE, },
    { key: 'drawingStatus', label: "Status", type: AimsCommonTableHeaderType.DYNAMIC, },
    { key: 'assignedDrafter', label: "Assigned Drafter", type: AimsCommonTableHeaderType.DYNAMIC, },
    { key: 'drawingNum', label: "Drawing Num", type: AimsCommonTableHeaderType.STRING, },
    { key: 'drawingTitle', label: "Title", type: AimsCommonTableHeaderType.STRING, },
    { key: 'pageNum', label: "Page", type: AimsCommonTableHeaderType.NUMBER, },
    { key: 'siteId', label: "Site", type: AimsCommonTableHeaderType.DYNAMIC, },
    { key: 'disciplineId', label: "Discipline", type: AimsCommonTableHeaderType.DYNAMIC, },
    { key: 'drawingSource', label: "Source", type: AimsCommonTableHeaderType.DYNAMIC, },
    { key: 'drawingTypeId', label: "Type", type: AimsCommonTableHeaderType.DYNAMIC, },
    { key: 'buildingNumber', label: "Building Num", type: AimsCommonTableHeaderType.STRING, },
    { key: 'comments', label: "Comments", type: AimsCommonTableHeaderType.STRING, width: 300 },
  ];

  tablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
    filter: false,
    export: false,
  };


  //***************************
  // Variables
  //***************************

  user = this.transferHttp.getCache("user");

  employeeValues = this.transferHttp.getCache('employeeDropdown');
  statusValues = this.transferHttp.getHot('ProjectSupport/GetDrawingStatuses');
  formatValues = this.transferHttp.getHot('ProjectSupport/GetDrawingFormats');
  disciplineValues = this.transferHttp.getHot('ProjectSupport/GetDrawingDisciplines');
  sourceValues = this.transferHttp.getHot('ProjectSupport/GetDrawingSources');
  typeValues = this.transferHttp.getHot('ProjectSupport/GetDrawingTypes');
  sitesValues = this.transferHttp.getCache('sitesDropdown');

  headerText: string = "Create New Drawing";

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = false;

  drawing: EngCadDrawings = new EngCadDrawings();
  @ViewChild('drawingForm', { static: true }) drawingForm: NgForm;

  editable = this.permissions.canUpdate(this.permissions.ComponentID.Drawing);

  //***************************
  // Functions
  //***************************

  //Prevents routing when unsaved changes
  canDeactivate(): Observable<boolean> {
    //Prevent navigation change / routing with unsaved changes
    if(this.drawingForm.dirty){
      return this.openUnsavedChangesConfirmModal()
    }else{
      return of(true)
    }
  }
  openUnsavedChangesConfirmModal():Observable<boolean>{
    var messsage = this.messageService.getDialogMessage(DialogComponent.UnsavedChanges)
    let dialogRef = this.dialog.open(AimsCommonConfirmDialogComponent, {
        data: messsage
    });
    return dialogRef.afterClosed();
  }

  saveDrawing() {
    this.spinnerText = "Saving...";
    this.transferHttp.save('ProjectSupport/SaveDrawing', this.drawing).subscribe(show => {
      this.showSpinner = show;
      if (!show) {
        this.loadDrawing(this.drawing.cadDrawingId);
      }
    });
  }

  loadDrawing(drawingId: number) {
    this.spinnerText = "Loading...";
    this.showSpinner = true;
    this.transferHttp.getHot(`ProjectSupport/GetDrawing?drawingId=${drawingId}`).subscribe(d => {
      this.drawing = d;
      this.headerText = "Update Drawing";
      this.drawingForm.form.markAsPristine();
      this.showSpinner = false;
    });
  }

  //***************************
  // Init
  //***************************

  ngOnInit(): void {
    this.route.params.subscribe(p => {
      if (p['drawingId']) {
        this.loadDrawing(p['drawingId']);
      }
      else {
        this.drawing.siteId = null;
        this.drawing.drawingStatus = null;
        this.drawing.pageNum = null;
      }
    });

  }

}
